export const SESSION_ITEM_ROW_CLASS =
  "flex items-start gap-1 border border-transparent pl-1 pr-3 py-2 rounded-lg";

export const SESSION_ITEM_ROW_WRAP_CLASS = "pb-0.5";

export const SESSION_ITEM_INDICATOR_GUTTER_CLASS =
  "flex w-4 shrink-0 items-center justify-center py-[7px]";

// With SessionSidebar's SESSION_CHILDREN_CLASS pl-1.5, puts nested titles 20px
// past the rail (ProjectDropGap and "Show more" pad to match).
export const NESTED_SESSION_ITEM_INDICATOR_GUTTER_CLASS =
  "flex h-4 w-3.5 shrink-0 items-center justify-center";

export const SESSION_SECTION_HEADER_BOX_CLASS =
  "w-full flex items-center justify-between px-3 pb-1 border border-transparent";

export const SESSION_FOOTER_CLASS =
  "flex-shrink-0 flex items-center justify-end px-4 pt-3 pb-2";

export const SESSION_FOOTER_LABEL_CLASS =
  "text-xs font-normal leading-4 text-neutral-500 dark:text-neutral-400";
